module.exports = __webpack_public_path__ + "static/media/webinar.cb57167f.png";